import {
  Checkbox,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { StyledTableCell } from "../../../../ui-components/StyledTables";
import RowSinglePermission from "./RowSinglePermission";
import { useSuperAdminPermissions } from "../../../../context/SuperAdmin/PermissionContext";
import { useAuthContext } from "../../../../hooks/Auth";

const SingleRolePermissionsTable = () => {
  const { permissions, selectedPermissions, setSelectedPermissions } =
    useSuperAdminPermissions();
  const { canAccess } = useAuthContext();

  const isNotProfessor = canAccess("delete:roleApps") && canAccess("create:roleApps");

  const selectAll = () => {
    setSelectedPermissions(
      permissions.map((permiso) => permiso.id_rol_permiso_comp)
    );
  };

  // Manejar selección/deselección de un permiso
  const handleSelect = (id: string) => {
    setSelectedPermissions((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  return (
    <TableContainer
      sx={{
        width: "100%",
        margin: "auto",
        borderRadius: 2,
        overflow: "hidden",
        mt: 2,
      }}
    >
      <Table sx={{ minWidth: 500, width: "100%" }} aria-label="simple table">
        {/* Cabecera de la tabla */}
        <TableHead sx={{ height: 20 }}>
          <TableRow>
            {isNotProfessor && <StyledTableCell sx={{ maxWidth: "100px", width: 50 }}>
              <Checkbox
                color="primary"
                checked={selectedPermissions.length > 0} // Check general
                onChange={(e) => {
                  if (e.target.checked) {
                    selectAll();
                  } else {
                    setSelectedPermissions([]);
                  }
                }}
                sx={{
                  color: "white", // Color del checkbox cuando no está seleccionado
                  "&.Mui-checked": {
                    color: "white", // Color del icono cuando está seleccionado
                  },
                  "& .MuiSvgIcon-root": {
                    border: "2px solid white", // Borde blanco alrededor del checkbox
                    borderRadius: "4px", // Bordes redondeados
                  },
                }}
              />
            </StyledTableCell>}
            <StyledTableCell>N°</StyledTableCell>
            <StyledTableCell>UmmIApps</StyledTableCell>
            <StyledTableCell>Fecha de adición</StyledTableCell>
          </TableRow>
        </TableHead>

        {/* Cuerpo de la tabla */}
        <TableBody>
          {permissions?.length ? (
            permissions.map((permiso, index) => (
              <RowSinglePermission
                key={permiso.id_rol_permiso_comp}
                permiso={permiso}
                index={index}
                isSelected={selectedPermissions.includes(
                  permiso.id_rol_permiso_comp
                )}
                handleSelect={handleSelect}
              />
            ))
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={9}
                sx={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                }}
              >
                No hay campos aún
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SingleRolePermissionsTable;
